import React from 'react';
import { Query } from 'react-apollo';
import Section from '../section/section';
import { GET_BAKERS } from '../../queries';
import classes from '../stepper/stepper.module.scss';
import Card from '../card/card';
import Slider from 'react-slick';
import { CircularProgress } from '@material-ui/core';

const PopularBakers = () => {
  return (
    <Query query={GET_BAKERS}>
      {({ loading, error, data }) => {
        if (loading) {
          return (
            <div style={{ textAlign: 'center' }}>
              <CircularProgress />
            </div>
          );
        }
        if (error) {
          return <div>Error fetching bakers</div>;
        }
        const { bakers } = data;
        const settings = {
          dots: false,
          infinite: bakers.length > 2,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 3,
          swipe: false,
          responsive: [
            {
              breakpoint: 1000,
              settings: {
                arrows: false,
                swipe: true
              }
            }
          ]
        };
        return (
          <Section title="Пекарі" count={bakers.length}>
            <Slider {...settings}>
              {bakers.map((baker: any) => {
                baker.image = baker.image || '/assets/profile_default.png';
                return (
                  <div key={baker.id} className={classes.step}>
                    <Card type={'bakers'} card={baker} />
                  </div>
                );
              })}
            </Slider>
          </Section>
        );
      }}
    </Query>
  );
};

export default PopularBakers;
